/*
 * biobio-pdp-layout.js
 *
 * Conserta o encavalamento do breakout de desktop da PDP-mestre.
 *
 * O PROBLEMA (medido no live em 30/07, 1440px):
 * `.row.product-container` e layout de FLOAT: a galeria (60%) e a coluna
 * `.product-form--main.half.column` (float: left, 40%) sao colunas irmas.
 * O breakout de `biobio-pdp.css` faz os blocos editoriais crescerem 250% pra
 * esquerda, invadindo a faixa horizontal da galeria. Isso so e seguro se o
 * bloco COMECAR abaixo do fim da galeria, e quem decide isso e a altura do
 * conteudo da coluna de info, que varia por produto:
 *
 *   BBS        galeria termina 1137, beneficios comeca 1034  ->  -103px (quebrado)
 *   Skindrops  galeria termina  947, beneficios comeca  951  ->    +4px (no fio)
 *   Bioretinol galeria termina  947, beneficios comeca 1013  ->   +66px
 *
 * Ou seja: latente nos tres, o BBS so foi o primeiro a cair (buy box curta,
 * sem tiers de oferta).
 *
 * POR QUE JS E NAO CSS:
 * `clear` nao resolve. A coluna de info e `float: left`, entao estabelece um
 * BFC proprio, e float de fora do BFC nao afeta quem esta dentro. As outras
 * saidas puras de CSS exigiriam saber a altura da galeria (que depende do
 * aspect ratio da imagem de cada produto) ou dissolver os wrappers do tema com
 * `display: contents` (quebra o padding mobile e as classes de animacao que o
 * JS do tema usa). Medir e empurrar e a opcao menor e reversivel.
 *
 * TRES ARMADILHAS QUE A REVISAO ADVERSARIAL PEGOU (30/07), todas reproduzidas
 * em CDP antes de existir esta versao:
 *
 * 1. A conta tem DUAS metades. Observar so a galeria deixa o push congelado
 *    quando quem muda e a coluna de info: trocar de tier esconde um
 *    `.pdp-offer__tier-body` inteiro (~80 a 140px), o alvo sobe e a invasao
 *    volta no primeiro clique. Por isso observamos a galeria E todos os irmaos
 *    ANTERIORES ao alvo. Nunca o alvo nem `.product-details` (que o contem):
 *    a margem que escrevemos realimentaria o observer.
 *
 * 2. Theme Editor. No re-render o Shopify troca o DOM da section inteira; o no
 *    observado sai do documento e o `<script src>` reinjetado re-executa e
 *    bate no guard, sem religar nada. Da segunda edicao em diante o fix ficava
 *    surdo e o editor mostrava o encavalamento como se fosse do tema. Por isso
 *    os listeners ficam no `document` (sobrevivem ao re-render) e o observer e
 *    RELIGADO a cada `apply()` quando o conjunto de nos muda.
 *
 * 3. Margem colapsada. O `margin-top` inline colapsa com a margem de baixo do
 *    irmao anterior (ex. `.product-seals { margin: 10px 0 }`), entao aplicar o
 *    valor medido de uma vez sai curto. Medimos de novo depois de aplicar, ate
 *    3 passadas, o que corrige exatamente sem adivinhar quanto colapsou.
 *
 * Sem JS a pagina volta ao estado de hoje: nada quebra alem do que ja esta.
 */
(function () {
  /* Estado UNICO no window. O `<script src>` re-executa a cada re-render de
   * section no Theme Editor; sem isso cada execucao criaria um
   * ResizeObserver novo e vazaria o anterior. Ja instalado = so re-mede. */
  if (window.__biobioPdpLayout) {
    window.__biobioPdpLayout.schedule();
    return;
  }

  var MQ = window.matchMedia('(min-width: 768px)');

  /* Respiro alvo abaixo da galeria QUANDO precisamos intervir. So mira isso
   * se houver invasao real; produto com folga natural nao e tocado. */
  var FOLGA = 24;
  var MAX_PASSES = 3;

  /* Os MESMOS tres predicados do breakout em biobio-pdp.css. Se um mudar la,
   * muda aqui: e o unico acoplamento do arquivo. */
  var BREAKOUT =
    ':scope > section[class*="pdp-"], :scope > .product-stories-videos, :scope > .compre-junto';

  var ro = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  var observados = [];

  function primeiroBreakout(details) {
    var kids = details.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].offsetHeight && kids[i].querySelector(BREAKOUT)) return kids[i];
    }
    return null;
  }

  /* Religa o observer na galeria e em todos os irmaos anteriores ao alvo, que
   * sao exatamente os que decidem onde o alvo comeca. Sai cedo se o conjunto
   * nao mudou, pra nao thrashar a cada frame. */
  function religar(details, gallery, target) {
    if (!ro) return;
    var novos = [gallery];
    for (var i = 0; i < details.children.length; i++) {
      if (details.children[i] === target) break;
      novos.push(details.children[i]);
    }
    var igual = novos.length === observados.length;
    if (igual) {
      for (var j = 0; j < novos.length; j++) {
        if (novos[j] !== observados[j]) { igual = false; break; }
      }
    }
    if (igual) return;
    ro.disconnect();
    observados = novos;
    for (var k = 0; k < novos.length; k++) {
      if (novos[k]) ro.observe(novos[k]);
    }
  }

  function apply() {
    var details = document.querySelector('.product-details');
    var gallery = document.querySelector('.product-gallery');
    if (!details || !gallery || !document.querySelector('pdp-offer')) return;

    var target = primeiroBreakout(details);
    if (!target) return;

    religar(details, gallery, target);

    // Zera antes de medir: senao o push anterior entra na conta e cresce sozinho.
    target.style.marginTop = '';
    if (!MQ.matches) return;

    // Sem invasao, nao toca em nada. Mantem Skindrops e Bioretinol byte a byte
    // como estao hoje, e o observer cobre o dia em que virarem invasao.
    if (gallery.getBoundingClientRect().bottom <= target.getBoundingClientRect().top) return;

    var aplicado = 0;
    for (var p = 0; p < MAX_PASSES; p++) {
      var falta =
        gallery.getBoundingClientRect().bottom + FOLGA - target.getBoundingClientRect().top;
      if (falta <= 0.5) break;
      aplicado += Math.ceil(falta);
      target.style.marginTop = aplicado + 'px';
    }
  }

  var pendente = false;
  function schedule() {
    if (pendente) return;
    pendente = true;
    requestAnimationFrame(function () {
      pendente = false;
      apply();
    });
  }

  window.__biobioPdpLayout = { schedule: schedule };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  }
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (MQ.addEventListener) MQ.addEventListener('change', schedule);

  // Troca de fonte muda altura de texto e move o alvo.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

  /* Theme Editor: no `document`, entao sobrevivem ao re-render da section (o
   * `unload` so desconecta; o proximo `apply` religa nos nos novos). */
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:block:select', schedule);
  document.addEventListener('shopify:block:deselect', schedule);
  document.addEventListener('shopify:section:unload', function () {
    if (ro) ro.disconnect();
    observados = [];
  });

  /* Rede pra navegador sem ResizeObserver: a troca de tier e a interacao que
   * mais mexe na altura da buy box. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name && e.target.name.indexOf('pdp-tier') === 0) schedule();
  });

  schedule();
})();
